import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getMe } from '../../../Services/API';

// -------------------------------------------------------------------------
// Thunks
// -------------------------------------------------------------------------

/**
 * Loads the current user + customer context.
 * Unchanged from the Yellowfin version — Bold BI needs the same user info.
 */
export const fetchMeInfo = createAsyncThunk(
    'biDashboard/fetchMeInfo',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getMe();
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// NOTE: fetchYfLoginToken has been removed.
// The Bold BI embed config is fetched directly in BoldBIDashboard.jsx
// via getBoldBIEmbedConfig(caseId) — no Redux thunk needed since it's
// a per-render call tied to the active caseId, not a global auth state.

// -------------------------------------------------------------------------
// Slice
// -------------------------------------------------------------------------

const biDashboardSlice = createSlice({
    name: 'biDashboard',
    initialState: {
        currentCustomer: null,
        currentUser: null,
        loading: false,
        meLoading: false,
        error: null,
    },
    reducers: {
        clearDashboardState: (state) => {
            state.currentCustomer = null;
            state.currentUser = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        // fetchMeInfo
        builder
            .addCase(fetchMeInfo.pending, (state) => {
                state.meLoading = true;
                state.error = null;
            })
            .addCase(fetchMeInfo.fulfilled, (state, action) => {
                state.meLoading = false;
                state.currentCustomer = action.payload.customer;  // extract customer only
                state.currentUser = action.payload.user;          // store user separately
            })
            .addCase(fetchMeInfo.rejected, (state, action) => {
                state.meLoading = false;
                state.error = action.payload || 'Failed to load user info';
            });
    },
});

export const { clearDashboardState } = biDashboardSlice.actions;
export default biDashboardSlice.reducer;
